import { render, staticRenderFns } from "./PurchFilters.vue?vue&type=template&id=6047a0db"
import script from "./PurchFilters.vue?vue&type=script&lang=js"
export * from "./PurchFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports